// extracted by mini-css-extract-plugin
export default {"container":"FilterMenuSwitch-module__container___WnSHQ","switch":"FilterMenuSwitch-module__switch____LvqR"};